<template>
  <div
    class="quote-details-container"
  >
    <base-table
      class="quote-table first-table"
    >
      <tr
        v-for="(item, index) in tableData"
        :key="index"
        :class="{'highlighted': index < 1}"
      >
        <td class="label">
          {{ item.name }}
        </td>
        <td class="value">
          {{ item.value }}
        </td>
      </tr>
    </base-table>
  </div>
</template>

<script>
import baseTable from './_baseTable.vue';
import { interestRate, currencyReals } from '../filters';
import { interestRateAnnual } from '../filters/interestRate';
import brazilDateFormat from '../filters/brazilDateFormat';

export default {
  name:       'BrazilQuoteDetails',
  components: { baseTable },
  props:      {
    quote: {
      type:     Object,
      required: true,
    },
  },
  computed: {
    tableData() {
      return [
        {
          name:  this.$t('components.quote_details.installment_amount'),
          value: currencyReals(this.quote.first_installment_amount, false),
        },
        {
          name:  this.$t('components.quote_details.number_of_installments'),
          value: this.quote.installments_requested,
        },
        {
          name:  'Valor total a ser pago',
          value: currencyReals(this.quote.gross_amount, false),
        },
        {
          name:  this.$t('components.quote_details.due_date_ordinal'),
          value: this.quote.first_due_date.slice(-2),
        },
        {
          name:  this.$t('components.quote_details.first_installment_date'),
          value: brazilDateFormat(this.quote.first_due_date),
        },
        {
          name:  this.$t('components.quote_details.last_installment_date'),
          value: brazilDateFormat(this.quote.last_due_date),
        },
        {
          name:  this.$t('components.quote_details.iof'),
          value: currencyReals(this.quote.tax_amount, false),
        },
        {
          name:  this.$t('components.quote_details.fee'),
          value: currencyReals(this.quote.expense_amount, false),
        },
        {
          name:  this.$t('components.quote_details.customer_rate'),
          value: interestRate(this.quote.customer_rate),
        },
        {
          name:  this.$t('components.quote_details.annual_customer_rate'),
          value: interestRateAnnual(this.quote.annual_customer_rate),
        },
        {
          name:  this.$t('components.quote_details.cet_rate'),
          value: interestRateAnnual(this.quote.cet_rate),
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
  .base-table {
    border: none;
  }
  .quote-details-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .quote-details-container.single-column {
    display: block;
  }

  .quote-table.first-table tr.highlighted {
    background-color: #fef5d5;
    font-weight: bold;
  }

  .quote-table tr:first-of-type {
    border-bottom: 1px solid #f0eeee;
  }

  .base-table {
    td {
      font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
    }
      td.label {
      font-size: 1rem;
      color: #333333;
    }

    td.value {
        font-size: 0.9rem;
        font-weight: 700;
        padding: 6px 0;
        color: #333333;
    }
  }

  tr:first-child {
    border: none;
    td {
      background-color: white;
      font-size: 1.15rem;
    }
    td:first-child {
      font-weight: 400;
      border-bottom: 0.3rem solid #f5bf05;
      border-left: 0.3rem solid #f5bf05;
      border-top: 0.3rem solid #f5bf05;
      border-bottom-left-radius: 10px;
      border-top-left-radius: 10px;
    }
    td:nth-child(2) {
      border-bottom: 0.3rem solid #f5bf05;
      border-right: 0.3rem solid #f5bf05;
      border-top: 0.3rem solid #f5bf05;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
  }

  tr:not(:first-child) {
    td {
      border-bottom: 1px solid rgb(174, 174, 174);
    }
  }
</style>
